<template>
    <div class="global-component">
        <CmsComponent
            v-for="(component, key) in data.components"
            :key="key"
            :background="data.backgroundColor"
            :data="component"
            :product="product"
            :related-products="relatedProducts"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type {
    ComponentGlobalComponentFragment,
    ShopWithConfidenceProductFragment,
} from '@/graphql/api'
import type { ButtonColors } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'
import type { Props as RelatedProductProps } from '@/components/rings/RelatedProducts.vue'
import CmsComponent from '@/components/cms/CmsComponent.vue'

const props = defineProps<{
    data: ComponentGlobalComponentFragment
    relatedProducts?: RelatedProductProps
    product?: ShopWithConfidenceProductFragment
}>()

const backgroundColor = computed(
    (): ButtonColors => cmsColorToButtonColor(props.data.backgroundColor)
)
</script>

<style lang="scss" scoped>
.global-component {
    background: v-bind(backgroundColor);
}
</style>
